import React, { useEffect } from 'react';

import {
    Box,
    Card,
    CardContent,
    Grid,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { ShowErrors } from 'common/components';
import { PlaceholderProductHeader } from 'common/components/placeholders';

import * as actions from './actions';
import { Form } from './components';
import * as selectors from './selectors';

const Container = ({
    control,
    formValues,
    handleClickDelete,
    isEnabledEdition,
    isFetchingDetail,
    isFetchingProductDetail,
    isUploadingThumbnail,
    placeholder,
    reset,
    setValue,
    thumbnail,
    uploadThumbnailErrors,
}) => {
    const { t } = useTranslation();

    useEffect(() => {
        return () => {
            reset();
        };
    }, []);

    const name = useWatch({ control, name: 'name' });

    const onHandleClickDelete = () => {
        handleClickDelete(formValues.id);
    };

    return (
        <PlaceholderProductHeader
            ready={
                isFetchingDetail ||
                isFetchingProductDetail ||
                isUploadingThumbnail
            }
        >
            <Card>
                <Grid container>
                    <Grid size={{ sm: 'auto', xs: 18 }}>
                        <Form
                            control={control}
                            formValues={formValues}
                            isEnabledEdition={isEnabledEdition}
                            onHandleClickDelete={onHandleClickDelete}
                            placeholder={placeholder}
                            setValue={setValue}
                            thumbnail={thumbnail}
                        />
                    </Grid>
                    <Grid size={{ sm: 'grow', xs: 18 }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <CardContent sx={{ flex: '1 0 auto' }}>
                                <Typography component="div" variant="h6">
                                    {name || t('Nameless')}
                                </Typography>

                                <ShowErrors
                                    errors={uploadThumbnailErrors}
                                    pt={2}
                                    severity="error"
                                    variant="filled"
                                />
                            </CardContent>
                        </Box>
                    </Grid>
                </Grid>
            </Card>
        </PlaceholderProductHeader>
    );
};

Container.propTypes = {
    control: PropTypes.object,
    formValues: PropTypes.object,
    handleClickDelete: PropTypes.func,
    isEnabledEdition: PropTypes.bool,
    isFetchingDetail: PropTypes.bool,
    isFetchingProductDetail: PropTypes.bool,
    isUploadingThumbnail: PropTypes.bool,
    placeholder: PropTypes.string,
    reset: PropTypes.func,
    setValue: PropTypes.func,
    thumbnail: PropTypes.object,
    uploadThumbnailErrors: PropTypes.array,
};

const mapStateToProps = createStructuredSelector({
    isFetchingProductDetail: selectors.getIsLoadingProductThumbnail,
    isUploadingThumbnail: selectors.getIsUploadingThumbnail,
    thumbnail: selectors.getDataProductThumbnail,
    uploadThumbnailErrors: selectors.getUploadThumbnailErrors,
});

const mapDispatchToProps = (dispatch) => ({
    fetchProductThumbnail: (id) => dispatch(actions.fetchProductThumbnail(id)),
    handleClickDelete: (id) => dispatch(actions.deleteThumbnail(id)),
    save: (values, id) => dispatch(actions.uploadThumbnail(values, id)),
    reset: () => dispatch(actions.reset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Container);
